<template>
  <v-app-bar
    app
    :height="extendedHeight"
    :extension-height="extendedHeight"
    clipped-left
    class="c360-header c360-header-wc"
  >
    <c360-wc-header
      class="c360-wc-header"
      :for-product="forProduct"
      :hide-logo="hideLogo"
      :clickable-logo="clickableLogo"
      :show-extension="showExtension.toString()"
      @header-logo-click="$emit('logo-click')"
      @header-height-changed="handleHeightChange"
      @header-error="catchError"
      @header-product-click="onProductClick"
    >
      <div slot="left" class="c360-header-left">
        <slot name="left" />
      </div>
      <div slot="center" class="c360-header-center">
        <slot name="center" />
      </div>
      <div slot="right" class="c360-header-right">
        <slot name="right" />
      </div>
    </c360-wc-header>
  </v-app-bar>
</template>

<script>
  import Vue from 'vue';
  import { productsSettings, getMyProducts } from '../model';

  import { usePortalLink } from '../../../shared/portal-link';

  export default Vue.extend({
    name: 'C360HeaderWc',

    inject: ['$c360', '$can', '$accessTokenProvider'],

    props: {
      /**
       * The name of the product the header is currently used for.
       */
      forProduct: {
        type: String,
        required: true,
      },

      /**
       * Whether the logo should be hidden.
       */
      hideLogo: {
        type: Boolean,
        default: false,
      },

      /**
       * Whether the logo should be clickable.
       * If set to true the logo will emit a __`logo-click`__ event on click.
       */
      clickableLogo: {
        type: Boolean,
        default: true,
      },

      useWebComponent: {
        type: Boolean,
        default: true,
      },

      showExtension: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        gqlProductList: [],
        extendedHeight: 88,
      };
    },

    async beforeMount() {
      const token = this.$accessTokenProvider();
      this.gqlProductList = await getMyProducts(token);
    },

    computed: {
      accessTokenProvider() {
        return this.$accessTokenProvider();
      },

      productsToDisplay() {
        return this.gqlProductList
          .map(({ id, enabled, tooltip }) => {
            if (productsSettings.has(id)) {
              const {
                meta: { name },
              } = productsSettings.get(id);

              return {
                name,
                id,
                wip: !enabled,
                disabled: !enabled,
                tooltip,
              };
            }

            return null;
          })
          .filter((item) => item !== null);
      },
      returnTo() {
        const { link } = usePortalLink(this.$c360.portalName);

        return { link };
      },
      logo() {
        return this.$c360.logo;
      },
    },

    watch: {
      async accessTokenProvider(token) {
        this.gqlProductList = await getMyProducts(token);
      },
    },

    methods: {
      catchError(error) {
        this.$emit('error', error);
      },
      onProductClick(event) {
        this.$emit('product-click', event.detail);
      },

      handleHeightChange(event) {
        this.extendedHeight = event.detail;
      },
    },
  });
</script>

<style scoped>
  .c360-wc-header {
    width: 100%;
    display: block;
  }

  .c360-header {
    background-color: var(--c360-color-background);
  }

  .c360-header-left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
  }

  .c360-header-right {
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
</style>
